import axios from "axios";
import { ACTIONS, REFRESH_STORAGE, URLS } from "../../_config";
import { getUserTimezone } from "../../_config/functions";
import { store } from "../../store";

function handle401() {
  store.dispatch({ type: ACTIONS.USER.LOGOUT });
  const postLoginRedirect = localStorage.getItem("postLoginRedirect");
  localStorage.clear();
  sessionStorage.removeItem(REFRESH_STORAGE);
  if (postLoginRedirect) {
    localStorage.setItem("postLoginRedirect", postLoginRedirect);
  }
  window.location.href = URLS.AUTH.LOGIN;
}

export class CallApi {
  static GET(url, params, isAuth, isAdaptive) {
    return new Promise((resolve, reject) => {
      let headers = {};
      const token = store.getState().user.token;
      if (token) {
        headers = {
          Authorization: `Bearer ${token}`,
        };
      }
      headers["X-Timezone"] = getUserTimezone();

      return axios({
        method: "GET",
        url,
        headers,
        params,
      })
        .then((success) => {
          return resolve(success);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401 && window.location.pathname != URLS.AUTH.LOGIN) {
            handle401();
          }
          return reject(error.response);
        });
    });
  }

  static POST(url, data, isAuth, isAdaptive) {
    return new Promise((resolve, reject) => {
      let headers = {};
      if (isAuth || isAdaptive) {
        const token = store.getState().user.token;
        if (token) {
          headers = {
            Authorization: `Bearer ${token}`,
          };
        }
      }
      headers["X-Timezone"] = getUserTimezone();

      const payload =
        data instanceof FormData
          ? data
          : data && typeof data === "object" && !Array.isArray(data)
            ? { ...data }
            : data;
      if (
        payload &&
        typeof payload === "object" &&
        !Array.isArray(payload) &&
        typeof payload.idempotency_key === "string" &&
        payload.idempotency_key.trim() !== ""
      ) {
        headers["Idempotency-Key"] = payload.idempotency_key.trim();
        delete payload.idempotency_key;
      }

      return axios({
        method: "POST",
        url,
        headers,
        data: payload,
      })
        .then((success) => {
          return resolve(success);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401 && window.location.pathname != URLS.AUTH.LOGIN) {
            handle401();
          }
          return reject(error.response);
        });
    });
  }

  static PUT(url, data, isAuth, isAdaptive) {
    return new Promise((resolve, reject) => {
      let headers = {};
      if (isAuth || isAdaptive) {
        const token = store.getState().user.token;
        if (token) {
          headers = {
            Authorization: `Bearer ${token}`,
          };
        }
      }
      headers["X-Timezone"] = getUserTimezone();

      return axios({
        method: "PUT",
        url,
        headers,
        data,
      })
        .then((success) => {
          return resolve(success);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401 && window.location.pathname != URLS.AUTH.LOGIN) {
            handle401();
          }
          return reject(error.response);
        });
    });
  }

  static DELETE(url, data, isAuth, isAdaptive) {
    return new Promise((resolve, reject) => {
      let headers = {};
      if (isAuth || isAdaptive) {
        const token = store.getState().user.token;
        if (token) {
          headers = {
            Authorization: `Bearer ${token}`,
          };
        }
      }
      headers["X-Timezone"] = getUserTimezone();

      return axios({
        method: "DELETE",
        url,
        headers,
        data,
      })
        .then((success) => {
          return resolve(success);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401 && window.location.pathname != URLS.AUTH.LOGIN) {
            handle401();
          }
          return reject(error.response);
        });
    });
  }
}
